import { Switch } from "@stardust-ds/react"
import { useState, useRef, useEffect } from "react"
import styles from "./index.module.scss"

export default function RcmpSimpleSwitch(props) {
  const { cDisabledText, cAbleText, onChange, value, bShowActive, ...oRest } = props
  const [isChecked, setIsChecked] = useState(Boolean(value))

  const elSwitchContainer = useRef(null)

  useEffect(() => {
    // set button type as button
    if (!elSwitchContainer?.current?.children?.length) return
    ;[...elSwitchContainer.current.children].map((el) => {
      if (el?.type === "submit") el.type = "button"
    })
  }, [])

  useEffect(() => {
    if (value === false) setIsChecked(false)
    if (value === true) setIsChecked(true)
  }, [value])

  useEffect(() => {
    onChange?.(isChecked)
  }, [isChecked])

  return (
    <div ref={elSwitchContainer} className={styles.switchContainer}>
      <p className={styles.optionText}>{cDisabledText}</p>
      <Switch
        checked={isChecked}
        onChange={setIsChecked}
        className={
          bShowActive && isChecked ? styles.switchComponentActive : styles.switchComponent
        }
        {...oRest}
      />
      <p className={styles.optionText}>{cAbleText}</p>
    </div>
  )
}
